import ApiService from "../api";

export default class ComissaoCaxiasService extends ApiService {

    constructor() {
        super("/api/comissoes/romaneio");
    }

    listar(filtros) {
        const params = new URLSearchParams();
        params.append('mes', filtros.mes);
        params.append('ano', filtros.ano);

        return this.get(`?${params.toString()}`)
    }

    gerarComissaoMotoristas(filtros) {
        const params = new URLSearchParams();
        params.append('mes', filtros.mes);
        params.append('ano', filtros.ano);

        return this.post(`/gerar-motoristas?${params.toString()}`)
    }

    gerarComissaoAuxiliares(filtros) {
        const params = new URLSearchParams();
        params.append('mes', filtros.mes);
        params.append('ano', filtros.ano);

        return this.post(`/gerar-auxiliares?${params.toString()}`)
    }
}
